import { fetchBaseQuery } from '@reduxjs/toolkit/query';

import { getAuthenticatedUser } from '@/shared/authentication/services/oidc';

/**
 * Builds the plain authenticated fetch base query for one backend host. All Bearer
 * hosts share this: the current OIDC access token is attached per request.
 */
export const makeBaseQuery = (getBaseUrl: () => string | undefined) =>
  fetchBaseQuery({
    baseUrl: getBaseUrl(),
    prepareHeaders: async headers => {
      const user = await getAuthenticatedUser();
      if (!user) return headers;
      headers.set('Authorization', `${user.token_type} ${user.access_token}`);
    }
  });
